import React, { useState, useEffect } from "react";
import { ModalComp, Notifs, Tour } from "../../shared";
import { FiPlus, FiBell, FiHome, FiVideo } from "react-icons/fi";
import { useTranslation } from "react-i18next";

const Notification = ({ openDash, toggleOptions, showOptions }) => {
  const { t } = useTranslation();
  const [showDashboard, setShowDashboard] = useState(false);

  const openDashboard = () => {
    setShowDashboard(!showDashboard);
    openDash(!showDashboard);
  };

  const [openModal, setOpenModal] = useState(false);
  const toggle = () => setOpenModal(!openModal);

  const [openTourModal, setOpenTourModal] = useState(false);
  const toggleTour = () => setOpenTourModal(!openTourModal);

  return (
    <>
      <ModalComp modal={openModal} toggle={toggle} component={<Notifs />} />
      <ModalComp
        modal={openTourModal}
        toggle={toggleTour}
        component={<Tour />}
      />
      <div className="d-flex align-items-center justify-content-center text-right notif">
        {/* Insert Button - Icon Only */}
        <i
          onClick={toggleOptions}
          className={`notificationCircle iconOnly text-center d-block cursor mx-1
                    d-flex align-items-center justify-content-center
                    ${showOptions ? "bg-priimary text-white" : ""}`}
          title={t("افزودن")}
        >
          <FiPlus className="notiffont" />
        </i>
        
        {/* Houses Button - Icon Only */}
        <i
          onClick={openDashboard}
          className={`notificationCircle iconOnly text-center d-block cursor
                    d-flex align-items-center justify-content-center
                     mx-1 ${showDashboard ? "bg-priimary text-white" : ""}`}
          title={t("خانه ها")}
        >
          <FiHome className="notiffont" />
        </i>
        
        {/* Notification Button - Icon Only */}
        <i
          onClick={toggle}
          className="notificationCircle iconOnly text-center d-block
                    d-flex align-items-center justify-content-center
                     cursor mx-1 position-relative"
          title={t("اعلانها")}
        >
          <FiBell className="notiffont" />
          <i className="notification d-block position-absolute rounded-circle "></i>
        </i>

        {/* Guide Button - Icon Only */}
        <a
          href="https://mmaviot.com/setup/"
          target="_blank"
          rel="noopener noreferrer"
          className="notificationCircle iconOnly text-center d-block cursor
            d-flex align-items-center justify-content-center mx-1"
          title={t("راهنما")}
        >
          <FiVideo className="notiffont" />
        </a>
      </div>
    </>
  );
};

export { Notification };
